import React from 'react';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';

const VoiceCallSlideTransition = React.forwardRef(function VoiceCallSlideTransition(
    props: TransitionProps & { children: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return (
        <Slide
            direction="up"
            ref={ref}
            {...props}
            timeout={{ enter: 480, exit: 320 }}
            easing={{
                enter: 'cubic-bezier(0.34, 1.2, 0.64, 1)',
                exit: 'cubic-bezier(0.4, 0, 0.2, 1)',
            }}
        />
    );
});

export default VoiceCallSlideTransition;
